export enum WebSocketEventType {
    USER_NOTIFICATION = 'USER_NOTIFICATION',
    UPLOAD_COMPLETE = 'UPLOAD_COMPLETE',
    PRICING_COMPLETE = 'PRICING_COMPLETE'
}
